"use strict";

exports.__esModule = true;
var _Overlay = _interopRequireDefault(require("./Overlay"));
exports.default = _Overlay.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}